import React from 'react'

import { Container, H1 } from '../index.js'

export default () => (
  <Container section>
    <H1>🔒 You are not authorized to view this page</H1>
  </Container>
)



// WEBPACK FOOTER //
// ./client/src/components/errors/NotAuthorized.js